import { Box, Stack, Typography } from "@mui/material"

import useAppStore from "store/app"

// import SingleAnswer from "./SingleAnswer"
// import GeneralQuestions from "./GeneralQuestions"
// import DefaultAnswers from "./DefaultAnswers"
import GrayButton from "components/shared/buttons/GrayButton"
import SecondaryButton from "components/shared/buttons/SecondaryButton"
import useAlertStore from "store/alert"
import useTranslation from "hooks/use_translation"
import BinaryQuestion from "./BinaryQuestion"

const Correction = () => {
  const prevStep = useAppStore((state) => state.prevAnamnesisStep)
  const createSymptom = useAppStore((state) => state.createSymptom)
  const getNextQuestion = useAppStore((state) => state.getNextQuestion)
  const finalStep = useAppStore((state) => state.finalStep)
  const updateSymptomsData = useAppStore((state) => state.updateSymptomsData)
  const toggleBackdrop = useAppStore((state) => state.toggleBackdrop)
  const showAlert = useAlertStore((state) => state.showAlert)
  const { direction } = useAppStore((state) => state.meta)

  const { currentQuestion, symptomsData } = useAppStore((state) => state.anamnesis)

  const { anamnesis } = useTranslation()

  const handleSubmit = (event) => {
    event.preventDefault()

    const data = Object.entries(symptomsData).map(([id, value]) => ({
      id: parseInt(id),
      active: value === "true" || value === true,
    }))

    if (data.length === 0) {
      showAlert(anamnesis?.correction_at_least, "primary")
      return
    }

    toggleBackdrop(true)
    createSymptom({ symptoms: data })
      .then(() => {
        updateSymptomsData({})

        getNextQuestion().then((exit_status) => {
          if (exit_status?.should_stop === true) {
            finalStep()
          }
        })
      })
      .finally(() => toggleBackdrop(true))
  }

  // const getComponent = {
  //   //required
  //   SINGLE_ANSWER: <SingleAnswer with_none={true} />,
  //   SINGLE_DEFINITION: <DefaultAnswers />,
  //   ADDITIONAL_SYMPTOMS: <DefaultAnswers />,
  //   MULTI_ANSWER: <DefaultAnswers />,
  //   HIGHT_DANGER_POSSIBLE: <DefaultAnswers />,
  //   // not required
  //   GENERAL_QUESTION: <GeneralQuestions with_single_question={true} />,
  //   MEDIUM_DANGER_POSSIBLE: <DefaultAnswers />,
  //   LOW_DANGER_POSSIBLE: <DefaultAnswers />,
  // }

  const getComponent = {
    //required
    BINARY: <BinaryQuestion />,
  }

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Typography variant="h6" sx={{ fontWeight: 500, mb: 1 }}>
        {currentQuestion?.name}
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
        {currentQuestion?.symptom_name}
      </Typography>

      {getComponent[currentQuestion?.type]}

      <Stack direction={direction === "rtl" ? "row-reverse" : "row"} columnGap={3}>
        <GrayButton text={anamnesis?.back_btn} fullWidth onClick={prevStep} />
        <SecondaryButton text={anamnesis?.next_btn} type="submit" fullWidth />
      </Stack>
    </Box>
  )
}

export default Correction
